import { IStudyGroupSectionsDatasource } from '../datasources/study_group_sections_datasource';
import { StudyGroupsQuery } from '../queries/study_groups_query';
import { StudyGroupsEmailServant } from '../servants/study_groups_email_servant';
import { ICourseSection } from '../study_group_interfaces';
import { StudyGroupsCapabilityConfiguration } from '../study_groups_configuration';

interface IModalContent {
  heading: string;
  prompt: string;
  className: string;
  content?: string;
  cancelButtonText?: string;
  confirmButtonText?: string;
  confirmationCallBack?: any;
  invertButtonStyles?: boolean;
}
export class StudyGroupModalService {
  private _isStudyGroupJoiningModalOpen: boolean;
  private _isStudyGroupDescriptionModalOpen: boolean = false;
  private _isStudyGroupEmailingModalOpen: boolean = false;
  private _modalContent: IModalContent;
  showBusySpinner: boolean = false;
  private section: ICourseSection;
  notificationDelegate: any;

  constructor(
    private $state: any,
    private ngStudyGroupsCapabilityConfiguration: StudyGroupsCapabilityConfiguration,
    private ngStudyGroupsEmailServant: StudyGroupsEmailServant,
    private phxNotificationDelegate: any
  ) {
    this._isStudyGroupJoiningModalOpen = false;
    this._modalContent = {
      heading: '',
      prompt: '',
      className: '',
      content: '',
      cancelButtonText: 'Cancel',
      confirmButtonText: 'Ok',
      invertButtonStyles: false
    };
    this.notificationDelegate = this.phxNotificationDelegate.restrictTo(
      this.ngStudyGroupsCapabilityConfiguration.config.notificationHandle
    );
  }

  generateNoneSelectedNotification(): void {
    this.notificationDelegate.create({
      status: 'warn',
      showIcon: true,
      iconClass: 'eab-icon eab-icon-caution',
      content: 'Please select at least one student from the list to email.',
      dismissOnTimeout: false
    });
  }

  get trigger() {
    return this.notificationDelegate;
  }

  get isStudyGroupDescriptionModalOpen(): boolean {
    return this._isStudyGroupDescriptionModalOpen;
  }

  get isStudyGroupJoiningModalOpen(): boolean {
    return this._isStudyGroupJoiningModalOpen;
  }

  get isStudyGroupEmailingModalOpen(): boolean {
    return this._isStudyGroupEmailingModalOpen;
  }

  show(modalContent: IModalContent): void {
    this._modalContent = modalContent;
    this._isStudyGroupJoiningModalOpen = true;
  }

  hide(): void {
    this._isStudyGroupJoiningModalOpen = false;
  }

  hideDescriptionModal(): void {
    this._isStudyGroupDescriptionModalOpen = false;
  }

  showDescriptionModal(): void {
    this._isStudyGroupDescriptionModalOpen = true;
  }

  hideEmailingModal(): void {
    this._isStudyGroupEmailingModalOpen = false;
  }

  showEmailingModal(sectionInfo: ICourseSection): void {
    this.section = sectionInfo;
    this._isStudyGroupEmailingModalOpen = true;
  }

  sendEmail(): void {
    if (this.ngStudyGroupsCapabilityConfiguration.config.emailService) {
      const { mailTo, subject, body } = this.ngStudyGroupsEmailServant.getEmailData(this.section);
      this.ngStudyGroupsCapabilityConfiguration.config.emailService.sendEmail({ to: mailTo, subject, body });
      this.hideEmailingModal();
    }
  }

  get modelContent(): IModalContent {
    return this._modalContent;
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-study-groups/src/modals/study_groups_modal_service.ts